<template>
  <div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
    <!-- <admin-sidebar-menu v-if="admin" /> -->
    <div class="content-wrapper">
      <div class="container-wrapper center">
        <div>
          <h3 class="d-inline heading mentor_name" style=" text-transform: capitalize;">{{  menteeName }}</h3>
        </div>
        <div class="heading-seperator"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-if="loading === false">
        <div v-show="tasklists_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>

        <flash-message autoHide variant="success"></flash-message>

        <div class="row mt-2">
          <div class="col-6 ">               
            <h5 class="task_name mt-2">{{ tasklist_name }}</h5>
          </div>
          <div class="col-4 p-0">
            <button class="btn btn-primary btn-sm task-goal-btn" @click="redirectTaskList">Task List</button>
          </div>
          <div class="col-2 col-sm-4 col-md-3 col-lg-2 col-xl-1 p-0">
          </div>

                               
          <div class="col-2 col-sm-4 col-md-3 col-lg-2 col-xl-3">
            <!--<input type="text" v-model="searchText" placeholder="Search task(s)" class="search-tasks"/>-->
          </div>
           
        </div>

            <div class="col-md-12 override-padding counter_heading-list" v-if="goals_result.length == 0">
                <div class="card">
                <div class="card-body">
                    <div class="no-goal-text">No Task Goals Set!</div>
                </div>
                </div>
            </div>
            <div class="col-md-12 override-padding counter_heading-list" id="tasks">
              <div v-for = "(item, gindex) in goals_result">
                  <div class="task-title-expand">
                  <b-link v-b-toggle="'collapse-' + item.noOfDays" size="sm" :class="'sub-heading ' + item.goalStatus+'_section'" @click="getFontIcon(item.noOfDays)">
                    <div class="d-flex bd-highlight">
                        <div class="flex-grow-1 bd-highlight goal_task_left" v-if="item.completionDate != 'January 1st, 1970'">Tasks Due {{ item.completionDate }}</div>
                        <div class="flex-grow-1 bd-highlight goal_task_left" v-else>Tasks with No Due Date</div>
                        <div class="bd-highlight">
                        <button v-if="item.goalStatus != 'completed' && item.completionDate != 'January 1st, 1970'" :class="'goal-indicator-btn ' + getBtnColor(item.goalStatus)">{{ getNoOfDays(item.noOfDays, item.goalStatus)}} </button>
                        <button v-if="item.goalStatus == 'completed'" :class="'goal-indicator-btn ' + getBtnColor(item.goalStatus)"><i class="fa fa-check completed_tick"></i></button>
                        </div>
                        <div class="bd-highlight goal_task_right">
                        <i class="fa fa-angle-down togIcon" :id="'angle-'+ item.sno" aria-hidden="true"></i>
                        </div>
                    </div>
                </b-link>
                </div>
                <b-collapse v-bind:id="'collapse-' + item.noOfDays" class="task-wrapper goallist">
                    <div class="col-md-12 override-padding counter_task-list">
                        <MenteeGoalTaskList
                        :itemLength="item.tasks.length" 
                        :allItems="item.tasks"
                        :menteeId="menteeId"
                        :tasklistId="tasklistId"
                        subTaskId=""
                        headingId=""
                        :goalSNo="item.noOfDays"
                        :progress="item.progress"
                        :privileges="privileges">
                    </MenteeGoalTaskList>
                    <div style="clear: both;"></div>
                    </div>
                </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import router from '../../router/index';
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import moment from 'moment';
import { store } from '../../store/store.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import MenteeGoalTaskList from './mentee_goal_task_list.vue';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

export default {
  data: function () {
    return {
       goals_result: [],
       isModalVisible: false,
       loading: false,
       tasklists: [],
       tasklistId: '',
       menteeId: '',
       subTaskId: '',
       menteeName: '',
       tasklists_loading: false,
       repCount: 0,
       mentorName: [],
       tasklist_name: '',
       privileges: '',
       user_type: '',
       userTypeName: '',
    }
  },
  methods: {
  showAssessmentofTasklist() {
     this.tasklists_loading = true;
     this.goals_result = [];
     axios.get('/desktop/mentee-subtask-goals/' + this.menteeId + '/' + this.tasklistId + '/' + this.$store.state.user_accountid)
      .then(response =>  {
        this.loading = false;
          this.tasklists_loading = false;
          this.goals_result = response.data.goals;
          // console.log(this.goals_result)
          // this.subtasks = response.data.subtasks;
      })
      .catch(function(error) {

      });
     axios.get('/desktop/mentees_tasklists_detail/' + this.menteeId + '/' + this.tasklistId + '/' + this.$store.state.user_accountid)
      .then(response =>  {
          this.tasklists_loading = false;
          this.tasklist_name = response.data.title;
      })
      .catch(function(error) {

      });
  },
  getFontIcon(id) {
    if (document.getElementById('collapse-' + id).style.display == "") {
      document.getElementById('angle-'+ id).className = "fa fa-angle-down";
    } else {
      document.getElementById('angle-'+ id).className = "fa fa-angle-up";
    }
  },
  getBtnColor(statusName) {
      if (statusName == "overdue") {
          return "redBtn";
      } else if (statusName == "yellow") {
          return "yellowBtn";
      } else if (statusName == "green") {
          return "greenBtn";
      } else {
          return "greenBtn";
      }
  },
  getNoOfDays(count, statusName) {
      if (statusName == "overdue") {
          return "Overdue";
      } else if (statusName == "completed") {
          return "";
      } else {
          return (count > 1) ? count + ' Days' : count + " Day";
      }
  },
  redirectTaskList() {
    router.push('/mentee-reps-tasklist/' + this.menteeId + '/' + this.tasklistId);
  }
  },
  components: {
    UserMenu,
    GoBack,
    AdminSidebarMenu,
    MenteeGoalTaskList,
  },
  created: function () {
    this.loading = true;
    this.menteeId = this.$route.params.mentee_id;
    this.tasklistId = this.$route.params.tasklist_id;
    this.showAssessmentofTasklist();
    var roles = store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }
  },
  mounted(){
        axios.get('/mobile/mentee-info', {
            params: {
                account_id: store.state.user_accountid,
                mentee_id: this.menteeId,
            }
        })
        .then(response =>  {
            this.menteeName = response.data.mentee_name;
            this.taskLists = response.data.tasklist;
            this.user_type = response.data.user_type;
            if (this.user_type == "apprentice") {
              this.userTypeName = "Apprentice";
            } else {
              this.userTypeName = "Mentee";
            }
            for(var i=0; i < response.data.groups.length; i++) {
                this.mentorName.push(response.data.groups[i].name);
            }
            this.privileges = response.data.privileges;
            //console.log(this.privileges)
        })
        .catch(function() {

        });
  },
  updated() {
   setTimeout(()=>{
    var e5_val = this.$route.query.e5;
    if((e5_val) || (e5_val == 0)) {
      var ele2 = document.getElementById("collapse-" + e5_val).parentElement.getElementsByClassName("task-title-expand")[0].getElementsByTagName("a")[0];
      
      //ele2.className = 'sub-heading overdue_section';
      
      document.getElementById("collapse-" + e5_val).parentElement.getElementsByClassName("task-title-expand")[0].getElementsByTagName("a")[0].setAttribute("aria-expanded", true);
      document.getElementById("collapse-" + e5_val).className = 'task-wrapper goallist collapse show';
      document.getElementById('collapse-' + e5_val).style.display = "block"
      if (document.getElementById('collapse-' + e5_val).style.display == "") {
        document.getElementById('angle-'+ e5_val).className = "fa fa-angle-down";
      } else {
        document.getElementById('angle-'+ e5_val).className = "fa fa-angle-up";
      }

    }
   }, 300);
  },

}
</script>

<style scoped>
.back-btn-wrapper {
  width:100%;
  margin-left: 10px;
  margin-right: 0px;
}
.mentee_name {
  font-size: 19px;
  margin-bottom: 0px;
}
hr {
  margin: 10px auto;
}
.custom_hr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin: 10px 0px;
  width: 100%;
}
.manageBtn, .manageBtn:active, .manageBtn:focus {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 10px;
  width: 120px;
  margin-left: 10px;
}
.mentor_name, .task_name {
    font-size: 16px;
    font-weight: 900;
}
.mentor_name span {
    font-weight: normal;
}
.task-goal-btn {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-size: 13px;
  font-weight: 900;
  padding: 8px;
  width: 120px;
  border-radius: 10px;
}
.sub-heading {
    padding: 10px;
    font-weight: 900;
    margin-bottom: 10px;
}
#tasks {
    padding: 0px;
}
.goal-indicator-btn {
    border-radius: 10px;
    font-size: 13px;
    padding: 5px;
    line-height: 12px;
    height: auto;
    width: 100px;
    text-align: center;
    outline: none !important;
}
.greenBtn, .greenBtn:active, .greenBtn:focus{
    color: #FFFFFF !important;
    background-color: #68C47E !important;
    border: 1px solid #68C47E !important;
}
.redBtn, .redBtn:active, .redBtn:focus {
    color: #FFFFFF !important;
    background-color: #FF0000 !important;
    border: 1px solid #FF0000 !important;
}
.yellowBtn, .yellowBtn:active, .yellowBtn:focus {
    color: #FFFFFF !important;
    background-color: #CBD538 !important;
    border: 1px solid #CBD538 !important;
}
.completed_tick {
  float: none !important;
  font-size: 18px !important;
}
.completed_section {
  background-color: #68C47E !important;
}
.goallist { 
  margin-top: -10px; 
}
.flex-grow-1 { padding-top: 5px; }
.no-goal-text {
  font-weight: 900;
  color: #002F42;
  padding: 20px;
  vertical-align: middle;
  text-align: center;
}
@media (min-width: 992px) {
  .goal-indicator-btn { margin-right:  200px;}
}
/* Small Devices */
/* Iphone 5 */
@media (min-width: 320px) and (max-width: 576px) { 
  .manageBtn {
    width: 60px;
  }
}
@media (min-width: 375px) and (max-width: 601px) { 
  .manageBtn {
    width: 98px;
  }
}
/* Ipad */
@media (min-width: 768px) and (max-width: 1024px) { 
  .manageBtn {
    width: 76px;
  }
}
/* Large Devices */
@media (min-width: 809px) and (max-width: 1024px) { 
  .goal_task_left { margin-left: 1.5rem; }
  .goal_task_right { margin-right: 1.5rem; }
}
/* Extra Large Devices */
@media (min-width: 1200px) {
  .goal_task_left { margin-left: 1.5rem; }
  .goal_task_right { margin-right: 1.5rem; }
}
</style>



// WEBPACK FOOTER //
// src/components/mentee/mentee_reps_goallist.vue